import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import LiveVotingBase from '../screens/LiveVoting/LiveVotingBase';
import LiveVotingSessionSelection from '../screens/LiveVoting/LiveVotingSessionSelection'

export default props => (
        <Switch>
            <Route path={`${props.match.path}/:liveVotingId`} exact component={LiveVotingBase} />
            <Route path={`${props.match.path}`} exact component={LiveVotingSessionSelection} />
            <Redirect to={`${props.match.path}`} />
        </Switch>
);
